export default __webpack_public_path__ + "static/N0312-e810b4ad5e65fef207da76501fba45ac.png";